import React, { useEffect } from 'react'
import i18n from 'i18next'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from './components/auth/useAuth'
import PrivateAdminRouter from './routers/PrivateAdminRouter'
import AdminRouter from './routers/AdminRouter'
import PrivateTechnicalRouter from './routers/PrivateTechnicalRouter'
import PrivateBreederRouter from './routers/PrivateBreederRouter'
import TechnicalRouter from './routers/TechnicalRouter'
import BreederRouter from './routers/BreederRouter'
import PublicRouter from './routers/PublicRouter'
import { useConnectionStatus } from './offline/connectionStatus'
import { syncAll } from './offline/syncService'

const t = i18n.t.bind(i18n)

export default function App() {

    useEffect(() => {
        //Cancela el scroll en los input tipo número para evitar que se modifiquen al subir o bajar en la página
        const handleWheel = (event) => {
            if (document.activeElement.type === 'number' && document.activeElement === event.target) {
                event.preventDefault()
            }
        }
        window.addEventListener('wheel', handleWheel, { passive: false })
        return () => { window.removeEventListener('wheel', handleWheel, { passive: false }) }
    }, [])

    const isOnline = useConnectionStatus()

    useEffect(() => {
        if (isOnline) {
            syncAll()
        }
    }, [isOnline])

    return (
	    <Provider store={store}>
            <React.StrictMode>
                <BrowserRouter> {/* BrowserRouter ahora envuelve toda la aplicación */}
                    <AuthProvider>
                        <Routes>
                            <Route path={`/${t("url.admin.admin")}/*`} element={<PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
                            <Route path={`/${t("url.technical.technical")}/*`} element={<PrivateTechnicalRouter><TechnicalRouter /></PrivateTechnicalRouter>} />
                            <Route path={`/${t("url.breeder.breeder")}/*`} element={<PrivateBreederRouter><BreederRouter /></PrivateBreederRouter>} />
                            <Route path="/*" element={<PublicRouter />}/>
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
            </React.StrictMode>
        </Provider>
    )
}